<template>
  <div id="active-input">
    <h4 class="sub-title">Active</h4>
    <div class="activeInput mt-4">
      <b-form-radio-group name="active" v-model="active">
        <b-form-radio :value="true">Yes</b-form-radio>
        <b-form-radio :value="false">No</b-form-radio>
      </b-form-radio-group>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ActiveInput',
  props: {
    singular: String,
    plural: String,
  },
  computed: {
    active: {
      get() {
        return this.$store.state[this.plural][this.singular].active;
      },
      set(val) {
        this.$store.commit(`${this.plural}/active`, val);
      },
    },
  },
};
</script>
